import React, { useContext, useEffect } from "react";
import { FiClock } from "react-icons/fi";
import AuthContext from "../../contexts/AuthContext";
import "./session-expired-modal.css";

// Mounted once, globally (see App.js) — any page's API call can flip
// `sessionExpired` via AuthContext.triggerSessionExpired() instead of each
// page handling a 401/403 with its own inline toast.
const SessionExpiredModal = () => {
  const { sessionExpired, confirmSessionExpired } = useContext(AuthContext);

  useEffect(() => {
    if (!sessionExpired) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape" || e.key === "Enter") confirmSessionExpired();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [sessionExpired, confirmSessionExpired]);

  if (!sessionExpired) return null;

  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">
          <FiClock size={26} />
        </div>
        <h3 className="session-expired-title">Session Expired</h3>
        <p className="session-expired-message">
          Your session has expired. Please login again.
        </p>
        <button
          type="button"
          className="session-expired-ok-btn"
          onClick={confirmSessionExpired}
          autoFocus
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
